<template>
    <div class="w-full min-h-screen flex flex-col bg-gray-100">
        <!-- Mobile filter dialog -->
        <mobile-filters :show="mobileFiltersOpen" :close="closeMobileFilters" :filters="computedFilters" @filter="this.handleInput($event)"/>

        <main>
            <title-banner
                :name="this.name"
                :description="this.description"
                :search-placeholder="this.searchPlaceholder"
                :searchable="this.searchable"
                :global-search="this.globalSearch"
                @search="this.handleSearch"
            />

            <!-- Filters -->
            <desktop-filters
                :filters="computedFilters"
                :sort-options="computedSorts"
                :active-filters="activeFilters"
                @sort="this.handleSort($event)"
                @filter="this.handleInput($event)"
                :show-mobile-filters="showMobileFilters"/>

            <!-- Scans grid -->
            <section class="max-w-2xl mx-auto pt-6 pb-16 px-4 sm:pt-8 sm:pb-24 sm:px-6 lg:max-w-7xl lg:px-8">
                <slot />
            </section>
        </main>
    </div>
</template>

<script>
import { ref, computed } from "vue";
import TitleBanner from '@/Shared/PageSegments/TitleBanner'
import MobileFilters from '@/Shared/PageSegments/MobileFilters'
import DesktopFilters from "@/Shared/PageSegments/DesktopFilters";

export default {
    components: {
        TitleBanner,
        MobileFilters,
        DesktopFilters,
    },
    props: {
        name: String,
        route: String,
        filters: Object,
        globalSearch: {
            default: false,
            type: Boolean
        },
        description: String,
        sortOptions: Object,
        searchable: {
            default: true,
            type: Boolean
        },
        searchPlaceholder: String,

        // Models
        sort: String,
        activeFilters: Object
    },
    computed: {
        computedSorts() {
            return this.sortOptions.map(sortOption => {
                return Object.assign(sortOption, {current: this.sort === sortOption.value});
            })
        },
        computedFilters() {
            return this.filters.map(filter => {
                const filterOptions = filter.options.map(filterOption => {
                    return Object.assign(filterOption, { checked: this.activeFilters.filter(
                        activeFilter => activeFilter.name === filter.id && activeFilter.value === filterOption.value).length > 0
                    })
                })

                return Object.assign(filter, {options: filterOptions});
            })
        },
    },
    setup(props, { emit }) {
        const mobileFiltersOpen = ref(false)

        return {
            mobileFiltersOpen,
        }
    },
    methods: {
        showMobileFilters() {
            this.mobileFiltersOpen = true
        },
        closeMobileFilters() {
            this.mobileFiltersOpen = false
        },
        makeRequest(argument, isSearch) {
            let search = typeof argument === 'string' && isSearch ? argument : ''
            let sort = typeof argument === 'string' && !isSearch ? argument : this.sort
            let filters = typeof argument === 'string' && !isSearch ? this.activeFilters : (isSearch ? [] : argument)
            let queryParams = {}

            if (search) {
                queryParams['search'] = search;
            }

            if (sort && sort.length > 0) {
                queryParams['sort'] = sort;
            }

            for (let activeFilter of filters) {
                if (queryParams[activeFilter.name]) {
                    if (typeof queryParams[activeFilter.name] === "string") {
                        queryParams[activeFilter.name] = [
                            queryParams[activeFilter.name],
                            activeFilter.value
                        ]
                    } else {
                        queryParams[activeFilter.name].push(activeFilter.value)
                    }
                } else {
                    queryParams[activeFilter.name] = `${activeFilter.value}`
                }
            }

            this.$inertia.get(this.$route(this.route), queryParams, { replace: true, preserveState: true });
        },
        handleSort(sort) {
            this.$emit('update:sort', sort)
            this.makeRequest(sort);
        },
        handleInput (section) {
            let activeFiltersClone = this.activeFilters.slice();
            let item = activeFiltersClone.filter(
                activeFilter => activeFilter.name === section.id && activeFilter.value === section.option.value
            )[0];
            if (section.option.checked && !item) {
                activeFiltersClone.push({
                    value: section.option.value,
                    valueLabel: section.option.label,
                    name: section.id, label: section.name,
                })
            } else if (item) {
                activeFiltersClone.splice(activeFiltersClone.indexOf(item), 1)
            }

            this.$emit('update:active-filters', activeFiltersClone)
            this.makeRequest(activeFiltersClone);
        },
        handleSearch(event) {
            this.$emit('search', event)
            this.makeRequest(event, true);
        }
    }
}
</script>
